<div class="table-container">
  <table mat-table matSort [dataSource]="datapointsDataSource" matSortActive="key" matSortDirection="asc">

    <ng-container matColumnDef="online">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'bacnet-datapoint.header.onlineStatus' | translate}}</th>
      <td mat-cell *matCellDef="let datapoint">
        <mat-icon *ngIf="datapoint.isOnline" class="wifi-on">wifi</mat-icon>
        <mat-icon *ngIf="!datapoint.isOnline" class="wifi-off">wifi_off</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="deviceId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="deviceId">{{'bacnet-datapoint.header.deviceName' | translate}}</th>
      <td mat-cell *matCellDef="let datapoint">{{datapoint.deviceId}}</td>
    </ng-container>

    <ng-container matColumnDef="key">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="key">{{'bacnet-datapoint.header.key' | translate}}</th>
      <td mat-cell *matCellDef="let datapoint">{{datapoint.key}}</td>
    </ng-container>

    <ng-container matColumnDef="dataType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="dataType">{{'bacnet-datapoint.header.dataPointName' | translate}}</th>
      <td mat-cell *matCellDef="let dataPoint">{{dataPoint.dataType}}</td>
    </ng-container>

    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="value">{{'bacnet-datapoint.header.lastValue' | translate}}</th>
      <td mat-cell *matCellDef="let dataPoint">{{dataPoint.value}}</td>
    </ng-container>

    <ng-container matColumnDef="unit">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="unit">{{'bacnet-datapoint.header.unit' | translate}}</th>
      <td mat-cell *matCellDef="let dataPoint">{{dataPoint.unit}}</td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="description">{{'bacnet-datapoint.header.description' | translate}}</th>
      <td mat-cell *matCellDef="let dataPoint">{{dataPoint.description}}</td>
    </ng-container>

    <ng-container matColumnDef="pollingIntervalSeconds">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="pollingIntervalSeconds">{{'bacnet-datapoint.header.pollingInterval' | translate}}</th>
      <td mat-cell *matCellDef="let dataPoint">{{dataPoint.pollingIntervalSeconds}}s</td>
    </ng-container>

    <ng-container matColumnDef="lastValue">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="lastValue">{{'bacnet-datapoint.header.lastValue' | translate}}</th>
      <td mat-cell *matCellDef="let dataPoint">{{dataPoint.lastValue}}</td>
    </ng-container>

    <ng-container matColumnDef="lastUpdated">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="lastUpdated">{{'bacnet-datapoint.header.lastUpdated' | translate}}</th>
      <td mat-cell *matCellDef="let dataPoint">{{dataPoint.lastUpdated | date:'dd.MM.yyyy HH:mm'}}</td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
<!--  <mat-spinner  diameter="48" strokeWidth="5" color="warn" *ngIf="true"></mat-spinner>-->
  <div class="display-flex-justify-center">
    <eon-ui-preloader-circle  size="big" *ngIf="loadingInProgress"></eon-ui-preloader-circle>
  </div>
</div>
